import React from 'react';
import config from './config';



class global{
    constructor(){
        this.config = new config();
        this.gapi = this.config.gapi;
    }

    fileSize = (b) => {
        var u = 0, s=1024;
        while (b >= s || -b >= s) {
            b /= s;
            u++;
        }
        return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
      }

    FileType = (file, event) => {
        let data;
        switch(file.mimeType){
            case 'application/vnd.google-apps.folder':
                data = <div id={file.id} className="fileLink" type="button" ><div><i className="fa-solid display-1 fa-folder"></i></div></div>
            break;
            case 'video/mp4':
                data = <div className="fileLink" data-json={JSON.stringify(file)}><a data-fancybox data-caption={`File Name: ${(file.name)} | File Size: ${this.fileSize(file.size)} | <a class="btn btn-sm btn-danger" href="${file.webContentLink}">Download</a>`} data-type="iframe" href={file.webContentLink.replace('=download',"=view")}><div><div>
                    {
                    file.thumbnailLink !== undefined ? 
                    <><img alt={file.name} className='thumbnail' referrerPolicy="no-referrer" data-json={JSON.stringify(file)} src={file.thumbnailLink} /></>:
                    <i className="fa-solid display-1 fa-file-video" data-json={JSON.stringify(file)}></i>
                    }
                    
                </div> </div></a></div>
            break;
            case 'video/vnd.dlna.mpeg-tts':
                data = <div className="fileLink" data-json={JSON.stringify(file)}><a data-fancybox data-caption={file.name} data-type="iframe" href={file.webContentLink.replace('=download',"=view")}><div><i className="fa-solid display-1 fa-file-video"></i></div></a></div>
            break;
            case 'video/x-matroska':
                data = <div className="fileLink" data-json={JSON.stringify(file)}><a data-fancybox data-caption={file.name} data-type="iframe" href={file.webContentLink.replace('=download',"=view")}><div><i className="fa-solid display-1 fa-file-video"></i></div></a></div>
            break;
            case 'image/jpeg':
            const imageUrl = `https://api.dreamzlive.com/gdrive-photo/?link=${file.thumbnailLink?.replace('=s220', '=s1024')}`;
                
            data = <div className="fileLink" data-json={JSON.stringify(file)}>
                <a data-fancybox 
                data-caption={`File Name: ${(file.name)} | File Size: ${this.fileSize(file.size)} | <a class="btn btn-sm btn-danger" href="${file.webContentLink}">Download</a>`}
                href={imageUrl}>
                <div>
                {file.thumbnailLink ? 
                    <img referrerPolicy="no-referrer" 
                            alt={''} 
                            className='thumbnail' 
                            data-json={JSON.stringify(file)} 
                            src={file.thumbnailLink} /> :
                    <i className="fa-solid fa-image"></i>
                }
                </div>
                </a>
            </div>



            break;
            case 'image/png':
                data = <div className="fileLink" data-json={JSON.stringify(file)}><a data-fancybox data-caption={`File Name: ${(file.name)} | File Size: ${this.fileSize(file.size)} | <a class="btn btn-sm btn-danger" href="${file.webContentLink}">Download</a>`} href={file.webContentLink.replace('=download',"=view")}><div>
                {
                file.thumbnailLink !== undefined ? 
                <><img referrerPolicy="no-referrer" data-json={JSON.stringify(file)} className='thumbnail' src={file.thumbnailLink} /></>:
                <i className="fa-solid fa-image"></i>
                }    
                </div></a></div>
            break;
            case 'image/svg+xml':
                data = <div className="fileLink" data-json={JSON.stringify(file)}><a data-fancybox data-caption={file.name} href={file.webContentLink.replace('=download',"=view")}><div>
                {
                file.thumbnailLink !== undefined ? 
                <><img referrerPolicy="no-referrer" data-json={JSON.stringify(file)} className='thumbnail' src={`https://lh3.google.com/u/0/d/${file.id}=w200-h190-p-k-nu-iv1`} /></>:
                <i className="fa-solid fa-image"></i>
                }    
                </div></a></div>
            break;
            case 'audio/mpeg':
                data = <div className="fileLink" data-json={JSON.stringify(file)}><a data-fancybox data-caption={file.name} data-type="iframe" href={file.webContentLink.replace('=download',"=view")}><div><i style={{color:'#7B2869'}} className="fa-solid display-1 fa-file-audio"></i></div></a></div>
            break;
            case 'application/x-zip-compressed':
                data = <div className="fileLink" data-json={JSON.stringify(file)} id={file.id} data-id={file.id}><a href={file.webContentLink}><div><i className="fa-solid display-1 fa-file-zipper"></i></div></a></div>
            break;
            
            case 'application/zip':
                data = <div id={file.id} className="fileLink" data-json={JSON.stringify(file)} data-id={file.id}><a href={file.webContentLink}><div><i className="fa-solid display-1 fa-file-zipper"></i></div></a></div>
            break;
            case 'application/pdf':
                data = <div id={file.id} className="fileLink" data-json={JSON.stringify(file)} data-id={file.id}><a data-fancybox data-caption={file.name} data-type="iframe" href={file.webContentLink.replace('=download',"=view")}><div><i className="fa-solid display-1 fa-file-pdf text-danger"></i></div></a></div>
            break;
            case ('text/csv'):
                data = <div id={file.id} className="fileLink" data-json={JSON.stringify(file)} data-id={file.id}><a href={file.webContentLink}><div><i className="fa-regular display-1 fa-file-csv"></i></div></a></div>
            break;
            case ('application/vnd.google-apps.spreadsheet'):
                data = <div id={file.id} className="fileLink" data-json={JSON.stringify(file)} data-id={file.id}><a href={file.webContentLink}><div><i className="fa-regular display-1 fa-file-excel"></i></div></a></div>
            break;
            case ('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'):
                data = <div id={file.id} className="fileLink" data-json={JSON.stringify(file)} data-id={file.id}><a href={file.webContentLink}><div><i className="fa-regular display-1 fa-file-excel"></i></div></a></div>
            break;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                data = <div id={file.id} className="fileLink" data-json={JSON.stringify(file)} data-id={file.id}><a href={file.webContentLink}><div><i className="fa-regular display-1 fa-file-word"></i></div></a></div>
            break;
            case 'application/vnd.google-apps.document':
                data = <div id={file.id} className="fileLink" data-json={JSON.stringify(file)} data-id={file.id}><a href={file.webContentLink}><div><i className="fa-regular display-1 fa-file-word"></i></div></a></div>
            break;
            default:
                
                data = <div id={file.id} className="fileLink" data-id={file.id}><a href={file.webContentLink}><div><i  data-json={JSON.stringify(file)} className="fa-solid display-1 fa-file"></i></div></a></div>
            break;
        }
        return data;
    }
    
}

export default global;